import { render } from "./CreateEditProjectForm.vue?vue&type=template&id=480574f2"
import script from "./CreateEditProjectForm.vue?vue&type=script&lang=js"
export * from "./CreateEditProjectForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__